import * as React from 'react';
import { ProcessAction } from '../../actions/DocActionActions';
import DocActionStore from '../../stores/DocActionStore';
class DocAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      actionStatus: 'pending',
      errorMessage: 'unknown error has occured',
      rejectReason: '',
    };
    this.onDocActionUpdate = this.onDocActionUpdate.bind(this);
    this.editRejectReason = this.editRejectReason.bind(this);
    this.onRejectClick = this.onRejectClick.bind(this);
    // bindings
  }

  componentDidMount() {
    DocActionStore.addChangeListener(this.onDocActionUpdate);
    console.log('docAction');
    let url = window.location.href;
    let idx = url.indexOf('?');

    console.log(idx);
    console.log(url.substring(idx + 1));
    let t = url.substring(idx + 1);

    if (t !== null && t !== undefined) {
      console.log('process action');
      ProcessAction(t, '');
    }
  }

  componentWillUnmount() {
    DocActionStore.removeChangeListener(this.onDocActionUpdate);
  }

  onDocActionUpdate() {
    let action = DocActionStore.getLastAction();
    let msg = DocActionStore.getLastError();
    this.setState({ actionStatus: action, errorMessage: msg });
  }

  editRejectReason(e) {
    this.setState({ rejectReason: e.target.value});
  }

  onRejectClick(){
    if(this.state.rejectReason.length > 0)
    {
      let url = window.location.href;
      let idx = url.indexOf('?');

      let t = url.substring(idx + 1);

      if (t !== null && t !== undefined) {
        console.log(this.state.rejectReason);
        console.log('process action');
        ProcessAction(t, this.state.rejectReason);
      }
    }
  }

  render() {
    return (
      <div className='container-fluid' style={{ height: '100%' }}>
        <div className='row flex-nowrap' style={{ height: '100%' }}>
          <div className='h-100 w-100 d-flex align-items-center'>
            {(this.state.actionStatus.toLowerCase() === 'approved' || this.state.actionStatus.toLowerCase() === 'approve') && (
              <div
                className='p-2 col-example'
                style={{
                  textAlign: 'center',
                  width: '100%',
                }}
              >
                <div style={{ width: '99%' }}>
                  <i
                    style={{ color: '#0DAA29' }}
                    className='fa-solid fa-thumbs-up'
                    size='6x'
                  />
                </div>

                <h3 style={{ fontWeight: 'bolder' }}>
                  Your document has been approved!
                </h3>
              </div>
            )}

            {(this.state.actionStatus.toLowerCase() === 'reject' || this.state.actionStatus.toLowerCase() === 'rejected') && (
              <div
                className='p-2 col-example'
                style={{
                  textAlign: 'center',
                  width: '100%',
                }}
              >
                <div style={{ width: '99%' }}>
                  <i
                    style={{ color: '#AA0D0D' }}
                    className='fa-solid fa-thumbs-down'
                    size='6x'
                  />
                </div>

                <h3 style={{ fontWeight: 'bolder' }}>
                  Your document has been rejected!
                </h3>
              </div>
            )}

            {this.state.actionStatus.toLowerCase() === 'reasonreq' && (
              <div
              className='p-2 col-example'
              style={{
                marginLeft: '10%',
                width: '40%',
              }}
              >
                <div className='form-group mb-2'>
                  <label><strong>Reason for reject:</strong></label>
                  <textarea className='form-control mt-2' rows='2' text={this.state.rejectReason} onChange={this.editRejectReason} />
                </div>
                <button className='btn btn-danger' onClick={this.onRejectClick}>Reject</button>
                </div>
            )}

            {this.state.actionStatus.toLowerCase() === 'error' && (
              <div
                className='p-2 col-example'
                style={{
                  textAlign: 'center',
                  width: '100%',
                }}
              >
                <div style={{ width: '99%' }}>
                  <i
                    style={{ color: '#AA0D0D' }}
                    className='fa-solid fa-times'
                    size='6x'
                  />
                </div>

                <h3 style={{ fontWeight: 'bolder' }}>
                  {this.state.errorMessage}
                </h3>
              </div>
            )}

            {this.state.actionStatus.toLowerCase() === 'pending' && (
              <div
                className='p-2 col-example'
                style={{
                  textAlign: 'center',
                  width: '100%',
                }}
              >
                <div style={{ width: '99%' }}>
                  <i
                    style={{ color: '#A5A5A5' }}
                    className='fa-solid fa-spinner'
                    size='6x'
                    spin
                  />
                </div>

                <h3 style={{ fontWeight: 'bolder' }}>Please wait...</h3>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default DocAction;
